<template>
  <v-autocomplete
    v-model="value.selecionado"
    :item-text="getUnidadeSiglaAndNome"
    :items="unidades"
    :search-input.sync="searchUnidade"
    item-value="id"
    class="mx-2"
    label="Unidade(s)"
    placeholder="Digite para pesquisar..."
    multiple
    prepend-icon="account_balance"
    return-object
    @change="searchUnidade = ''"
  >
    <template
      v-if="unidades.length > 0"
      v-slot:prepend-item
    >
      <v-list-item @click="toggleItens">
        <v-list-item-action>
          <v-icon :color="value.selecionado.length > 0 ? 'primary' : ''">
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Selecionar Todas</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2" />
    </template>
    <template v-slot:selection="data">
      <v-chip
        :input-value="data.selected"
        class="chip--select-multi"
        close
        color="primary"
        search=""
        small
        text-color="white"
        @click:close="removeUnidade(data.item)"
      >
        {{ data.item.sigla }}
      </v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'SelectMultipleUnidades',

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        isTodasSelecionadas: false,
        selecionado: [],
        visualizacao: '',
      }),
    },
    mapeamentoId: {
      type: Number,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      searchUnidade: '',
    };
  },

  computed: {
    ...mapState({
      comissao: (state) => state.auth.comissao,
      usuariosMapeamentos: (state) => state.mapeamento.usuariosMapeamentos,
      mapeamentosComissao: (state) => state.mapeamento.mapeamentosComissao,
    }),
    ...mapGetters({
      getUnidadesByAcesso: 'unidade/getUnidadesByAcesso',
    }),
    unidades() {
      if (!this.mapeamentoId) {
        return [];
      }
      let unidades;
      if (this.comissao) {
        // necessário informar o mapeamento? será sempre o selecionado, não?
        const mapeamento = this.mapeamentosComissao.find((m) => m.id === this.mapeamentoId);
        unidades = [mapeamento.unidade, ...mapeamento.unidades];
      } else {
        unidades = this.getUnidadesByAcesso('COMUM', this.mapeamentoId);
      }

      return unidades.sort((a, b) => a.nome.localeCompare(b.nome));
    },
    selectAllItens() {
      return this.value.selecionado.length === this.unidades.length;
    },
    selectSomeItens() {
      return this.value.selecionado.length > 0 && !this.selectAllItens;
    },
    isTodasSelecionadas() {
      return this.value.selecionado.length === this.unidades.length;
    },
    icon() {
      if (this.selectAllItens) {
        return 'check_box';
      }
      if (this.selectSomeItens) {
        return 'indeterminate_check_box';
      }
      return 'check_box_outline_blank';
    },
    visualizacaoUnidades() {
      if (this.value.isTodasSelecionadas && this.value.selecionado.length > 1) {
        return '(TODAS)';
      } if (this.value.selecionado.length > 0) {
        return `(${this.value.selecionado.map((u) => u.sigla).join(', ')})`;
      }
      return '';
    },
  },

  watch: {
    isTodasSelecionadas(newValue) {
      this.value.isTodasSelecionadas = newValue;
    },
    'value.selecionado': function () {
      this.value.visualizacao = this.visualizacaoUnidades;
    },
    unidades() {
      this.value.selecionado = [];
      this.value.visualizacao = '';
      this.value.isTodasSelecionadas = false;
    },
  },

  methods: {
    getUnidadeSiglaAndNome(item) {
      return `${item.sigla} - ${item.nome}`;
    },
    removeUnidade(item) {
      const index = this.value.selecionado.findIndex((u) => u.id === item.id);
      if (index !== -1) {
        this.value.selecionado.splice(index, 1);
      }
    },
    toggleItens() {
      this.$nextTick(() => {
        if (this.selectAllItens) {
          this.value.selecionado = [];
        } else {
          this.value.selecionado = [...this.unidades];
        }
      });
    },
  },
};
</script>
